export class NoNetworkError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
